export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[520px] md:min-h-[600px]">
      <div className="flex-1 relative overflow-hidden bg-background-100">
        <img
          src="https://readdy.ai/api/search-image?query=Stylish%20person%20in%20elegant%20neutral%20tone%20outfit%20walking%20confidently%20through%20sun-dappled%20Milanese%20courtyard%2C%20warm%20golden%20afternoon%20light%2C%20soft%20cinematic%20atmosphere%2C%20sophisticated%20Italian%20street%20style%20editorial%2C%20cream%20stone%20architecture%20background%2C%20refined%20lifestyle%20fashion%20photography&width=1200&height=900&seq=cta-fashion-v2&orientation=portrait"
          alt="Itaobuy Sheet Shopping"
          title="itaobuy sheet - Shopping Agent"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent" />
        <div className="absolute top-8 left-8">
          <span className="text-foreground-700 text-xs font-medium tracking-widest uppercase">
            Shopping Agent
          </span>
        </div>
        <div className="absolute bottom-8 left-8">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-background-50 leading-[1.05] tracking-tight">
            itaobuy<br />sheet
          </h2>
        </div>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center bg-background-50 px-8 md:px-16 py-14 md:py-0">
        <div className="max-w-md text-center">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 leading-[1.05] tracking-tight mb-6">
            Acquista<br />Ora
          </h2>
          <p className="text-foreground-600 leading-relaxed mb-8 text-sm md:text-base">
            Esplora il catalogo completo su Itaobuy Spreadsheet. Migliaia di prodotti selezionati, 
            prezzi competitivi e spedizioni affidabili. Inizia subito il tuo shopping intelligente.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            buy it now
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}